  <section #pdfControls class="pdf-controls">
    <div class="control d-flex flex-row-reverse">
      <span *ngIf="isLoaded" class="bo-label-text vo-pagination-left-label-text vo-heading-regular-16 vo-pdf-controls__pagination-arrows"
        [innerHtml]="referenceDataLabels.PdfViewerPaging|localizeLabel|formatString:[page,totalPages]"></span>
      <div>
        <button (click)="prevPage()" [disabled]="!isLoaded || page === 1" class="control-button prev-button"></button>
        <button (click)="nextPage()" [disabled]="!isLoaded || page === totalPages" class="control-button next-button"></button>
      </div>
    </div>

    <ng-content></ng-content>

    <div class="control">
      <span *ngIf="isLoaded" class="bo-label-text vo-heading-regular-16 vo-zoom-right-label-text" [innerHtml]="referenceDataLabels.Zoom|localizeLabel"></span>
      <button (click)="zoomOut()" [disabled]="!isLoaded || zoom <= minZoom" class="control-button out-button"></button>
      <button (click)="zoomIn()" [disabled]="!isLoaded || zoom > 2" class="control-button in-button"></button>
    </div>
  </section>

<pdf-viewer [ngClass]="{'pdf-viewer__loading-spinner': !isLoaded}" class="actual-pdf-viewer" [src]="pdfSrc"
  [show-all]="false" [(page)]="page" [zoom]="zoom" [render-text]="true" [original-size]="true" [fit-to-page]="true"
  (after-load-complete)="afterLoadComplete($event)" (page-rendered)="onPageRendered()" (error)="onError()">
</pdf-viewer>
